
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/macro-plan",
      function () {
        return require("private-next-pages/macro-plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/macro-plan"])
      });
    }
  